import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { PaginatedCheckInProgramListList } from 'types';
import { client } from 'utils/api-client';

function useCommittedClubProgram(): UseQueryResult<AxiosResponse<PaginatedCheckInProgramListList>> {
  return useQuery(['committedClubProgram'], () => client.get('check-in-program/program/'));
}

export default useCommittedClubProgram;
